export const formatDateWithNoHours = (date: string): string => {
  const dateObj = new Date(date).toISOString().split('T')[0];

  return dateObj.split('-').reverse().join('/');
};